import { render, staticRenderFns } from "./InfosMobile.vue?vue&type=template&id=ef545c18&"
import script from "./InfosMobile.vue?vue&type=script&lang=js&"
export * from "./InfosMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports